const genderTypes = [
  {
    _id: "",
    name: "Select | اختر",
    disabled: true,
  },
  {
    _id: "0",
    name: "Male | ذكر",
  },
  {
    _id: "1",
    name: "Female | أنثى",
  },
];

export default genderTypes;
